import './style.css';

import {
  colors,
  ImpHeader,
  ImpInlineLink,
  ImpPad,
  ImpText,
} from '@imprint-payments/imprint-ui';
import bemmy from 'bemmy';
import { useState } from 'react';

import { useImpState } from '../../app/hooks';
import { RewardsTrigger } from '../../components/AlreadyAppliedText/AlreadyAppliedText';
import { LockupImage } from '../../components/LockupImage/LockupImage';
import { getIssuerDisclosureInStore } from '../../utils/disclosures';
import { ProductUUID } from '../../utils/productUUIDConstants';
import ImprintLogo from './assets/imprint-logo.svg';
import ChannelSelection from './ChannelSelection';
import InviteCustomer from './InviteCustomer';
import { getDisclosureLinks } from './utils';

const BLOCK = 'store-route';
const bem = bemmy(BLOCK);

const STEPS = {
  INVITE: 'INVITE_CUSTOMER',
  CHANNEL_SELECTION: 'CHANNEL_SELECTION',
} as const;

type Step = (typeof STEPS)[keyof typeof STEPS];

export default function Store() {
  const { consumerInfo, language, languageCode, merchantData } = useImpState();
  const productUUID = merchantData.productUUID as ProductUUID;
  const cardName = merchantData.rewardDetails.cardName;
  const { rewardsTermsAndConditions, cca } = getDisclosureLinks(
    merchantData.productUUID,
    languageCode
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [step, setStep] = useState<Step>(STEPS.INVITE); // TODO: setStep

  return (
    <div className={bem()}>
      <div className={bem('header-container')}>
        <ImpHeader
          leadingContent={
            <ImpPad paddingTop="m" paddingBottom="m">
              <LockupImage />
            </ImpPad>
          }
          trailingContent={<RewardsTrigger breakpoint={Infinity} />}
        />
      </div>

      <section className={bem('content')}>
        {step === STEPS.INVITE && <InviteCustomer />}
        {step === STEPS.CHANNEL_SELECTION && <ChannelSelection />}
      </section>

      <footer className={bem('footer')}>
        <div className={bem('footer-row')}>
          <ImpText
            typography="body3"
            color={colors.content.onSurfaceVariant}
            key="offer-disclosure-text"
          >
            *{language.offerDisclosure1}
            <ImpInlineLink url={rewardsTermsAndConditions} underline>
              {language.offerDisclosure2}
            </ImpInlineLink>
            {language.offerDisclosure3}
            <ImpInlineLink
              url={consumerInfo.cardOffer.cardholderAgreementURL || cca}
              underline
            >
              {language.offerDisclosure4}
            </ImpInlineLink>
            {language.offerDisclosure5}
          </ImpText>

          <ImpText color={colors.content.onSurfaceVariant} typography="body3">
            {getIssuerDisclosureInStore(productUUID, cardName, language)}
          </ImpText>
        </div>
        <div className={bem('footer-row', { logo: true })}>
          <img height={60} src={ImprintLogo} alt="Imprint Logo" />
        </div>
      </footer>
    </div>
  );
}
